import { Component,OnInit } from '@angular/core';
import { Routes,Router,RouterModule}  from '@angular/router';
import { AppComponent } from '../app.component';
import { TopnavComponent } from '../topnav/topnav.component';
import { ShopSidemenuComponent } from '../shopsidemenu/shopsidemenu.component'; 
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { AppSettings } from '../appSettings';
import { LoginService } from '../services/login.service';
import { CommonService } from '../services/common.service';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2'

declare var jquery:any;
declare var $ :any;
import { Injectable } from '@angular/core';

@Component({
  selector: 'app-shopdashboard',
  templateUrl: './shopdashboard.component.html',
  styleUrls: ['./shopdashboard.component.css']
})



export class ShopDashboardComponent implements OnInit {
  currentUser:any;
  currentUserID:any;
  currentUsername:any;
  currentUsergroup:any;
  currentUserStatus:any;
  details_array:any=[];
  currentAllUsers:any;
  tamount:any;
  payment_details:any
  packagelist:Array<Object>;
  package_vs_user_list:Array<Object>;
  model: any = {};
  model2: any = {};
  transmodel:any={};
  elearningmodel:any={};
  alldata: any = {};
  payment_data:any={};
  transferdata: any = {};
  InstructorTransferDate:any={};
  renew_payment_details:any=false;
  select: any;
  isPaid:Boolean=false;
  userwebsiteurl:string=AppSettings.userweburl;
  getpackageinfodetApiUrl:string = AppSettings.getPackageInfo; 
  checkIswebsite:Boolean=false;
  checkUserRestApiUrl:string = AppSettings.checkuserdetail; 
  checkpackageisactivated:string = AppSettings.packageisactivated; 
  checkUserCreditRestApiUrl:string = AppSettings.checkusercredit;
  checkUserCreditbyTypeRestApiUrl:string = AppSettings.checkusercreditbytype;
  getpackagelistRestApiUrl:string = AppSettings.getPackageDetail; 
  inserttrasnfeprocessRestApiUrl:string = AppSettings.inserttransferprocess;
  getpackagevsuserApiUrl:string = AppSettings.getPackageNotbuy;
  insertpackagevsuserApiUrl:string = AppSettings.insertpackagevsuser;
  packageActivateApiUrl:string = AppSettings.PACKAGE_ACTIVATE;
  CheckwebsiteExistsRestApiUrl:string = AppSettings.checkwebsitedetail; 
  FetchMeSettingApiUrl: string = AppSettings.getmesettings;
  convertmeApiUrl: string = AppSettings.convertme;
  showButton:Boolean=false;
  userRole:any;
  activeTab: string = 'create';
  meCreateItems: Array<any> = [];
  meGrowItems: Array<any> = [];
  packagelistall:Array<Object>;
  websiteurl:string=AppSettings.USER_TEMPLATE;
  showLoginForm: boolean = false;
  selectedOption: string = '';
  showBuySale: boolean = false;
  showBuy: boolean = false;
  currentWeek:any;
  nextWeek:any;
  totalWeeks:any=700;
  showComingSoon = false;
  showShortMenu = false;

  melist: any = {
    ai_dollar: 0,
    me_ai: 0,
    me_main: 0,
    me_life: 0
  };
  convertmodel: any = {};
 
  constructor(private loginService: LoginService,private CommonService: CommonService,private router: Router,private http:Http,private translate:TranslateService) { 
      document.body.className="theme-red";

  }

  ngOnInit() {
    this.loginService.localStorageData();
    this.updateWeek();
    this.loginService.viewsActivate();
    this.renew_payment_details=true;
    this.showButton=false;
    this.userRole=localStorage.getItem('userRole');
    this.model2.usergroup=localStorage.getItem('currentUsergroup');
    this.model2.id = localStorage.getItem('currentUserID');
    this.model2.email = localStorage.getItem('email');
    this.model2.name = localStorage.getItem('currentUser');
    let id=localStorage.getItem('currentUserID');
      this.CommonService.editdata(this.checkpackageisactivated,id).subscribe(data=>{
         if(data.exist==2)
          {
           
           this.router.navigate(['./packageinfo']); 
          }
      });

      this.CommonService.getdata(this.FetchMeSettingApiUrl).subscribe(meresultdata =>{
        console.log("mesetting->dashboard-->",meresultdata.data[0]); 
        this.melist.ai_dollar = meresultdata.data[0].ai_dollar;
        this.melist.me_ai = meresultdata.data[0].me_ai;
        this.melist.me_main = meresultdata.data[0].me_main;
        this.melist.me_life = meresultdata.data[0].me_life; 
        // this.model.id = meresultdata.data[0].id; 
      });
      
      this.CommonService.getdata(this.getpackagelistRestApiUrl)
        .subscribe(packagedet =>{
            if(packagedet.result!="")
            { 
              this.packagelistall= packagedet.result;
            } 
        });
        this.model.selectedwebsite_prefix="p-"; //default personal life
        this.model.pcktaken='17'; //default personal life

       let user_id = localStorage.getItem('currentUserID');
       this.tamount = localStorage.getItem('tamount');
       this.model.user_id = user_id;
      this.CommonService.editdata(this.getpackageinfodetApiUrl,user_id)
          .subscribe(resultdata =>{   
            console.log("resultdata-->",resultdata);
            this.packagelist=resultdata.result; 
            this.model.tot_amt=resultdata.result[0]['tamount']; 
            this.model.tamount_renewal=resultdata.result[0]['tamount_renewal']; //ME Money
            this.model.instructor_amount=resultdata.result[0]['instructor_amount'];
            this.model.instructor_amount_renewal=resultdata.result[0]['instructor_amount_renewal'];
            this.model.e_amt=resultdata.result[0]['eamount'];
            this.model.eamount_renewal=resultdata.result[0]['eamount_renewal']; 
            this.model.pw_amount=resultdata.result[0]['pw_amount'];
            this.model.pw_amount_renewal=resultdata.result[0]['pw_amount_renewal'];
            this.model.bw_amount=resultdata.result[0]['bw_amount'];
            this.model.bw_amount_renewal=resultdata.result[0]['bw_amount_renewal'];
            this.model.mall_amount=resultdata.result[0]['mall_amount'];
            this.model.mall_amount_renewal=resultdata.result[0]['mall_amount_renewal'];
            this.model.floor_amount=resultdata.result[0]['floor_amount'];
            this.model.floor_amount_renewal=resultdata.result[0]['floor_amount_renewal'];
            this.model.shop_amount=resultdata.result[0]['shop_amount'];
            this.model.shop_amount_renewal=resultdata.result[0]['shop_amount_renewal'];
            this.model.me_ai_amount=resultdata.result[0]['me_ai_amount'];
            this.model.dollar_amount=resultdata.result[0]['dollar_amount']; 
            this.model.growME=resultdata.result[0]['growME']; 
            this.model.ai_dollar=resultdata.result[0]['ai_dollar'];
            
            this.meCreateItems = [
              { icon: 'assets/images/dollar.png', title: 'AI Dollar', rate: '1$ = 1$', mainValue: this.model.ai_dollar, subValue: this.model.ai_dollar },
              { icon: 'assets/images/dollar.png', title: 'Dollar', rate: '1$ = 1$', mainValue: this.model.dollar_amount, subValue: this.model.dollar_amount },
              { icon: 'assets/images/ME-Logo-100x100.png', title: 'ME AI', rate: '1 ME = 1$', mainValue: this.model.me_ai_amount, subValue: this.model.me_ai_amount },
              { icon: 'assets/images/ME-Logo-100x100.png', title: 'ME Money', rate: '1 ME = 1$', mainValue: this.model.tamount_renewal, subValue: this.model.tamount_renewal},
              { icon: 'assets/images/ME-Logo-100x100.png', title: 'ME Grow', rate: '1 ME = 1$', mainValue: this.model.growME, subValue: this.model.growME },
              { icon: 'assets/images/ME-Logo-100x100.png', title: 'ME Entrepreneur', rate: '1 ME = 100$', mainValue: this.model.tot_amt, subValue: (this.model.tot_amt*100) },
              { icon: 'assets/images/ME-Logo-100x100.png', title: 'ME Main', rate: '1 ME = 10$', mainValue: this.model.pw_amount, subValue: (this.model.pw_amount*10) },
              { icon: 'assets/images/ME-Logo-100x100.png', title: 'ME Business', rate: '1 ME = 300$', mainValue: this.model.bw_amount, subValue: (this.model.bw_amount*300) },
              { icon: 'assets/images/ME-Logo-100x100.png', title: 'ME Instructor', rate: '1 ME = 370$', mainValue: this.model.instructor_amount, subValue: (this.model.instructor_amount*370) },
              { icon: 'assets/images/ME-Logo-100x100.png', title: 'ME Student', rate: '1 ME = 10$', mainValue: this.model.e_amt, subValue: (this.model.e_amt*10) },
              { icon: 'assets/images/ME-Logo-100x100.png', title: 'ME Mall', rate: '1 ME = 3000$', mainValue: this.model.mall_amount, subValue: (this.model.mall_amount*3000) },
            ];

            this.meGrowItems = [
              { icon: 'assets/images/ME-Logo-100x100.png', title: 'ME Main', rate: '1 ME = 1$', mainValue: this.model.pw_amount_renewal, subValue: (this.model.pw_amount_renewal*1) },
              { icon: 'assets/images/ME-Logo-100x100.png', title: 'ME Business', rate: '1 ME = 3$', mainValue: this.model.bw_amount_renewal, subValue: (this.model.bw_amount_renewal*3) },
              { icon: 'assets/images/ME-Logo-100x100.png', title: 'ME Instructor', rate: '1 ME = 7$', mainValue: this.model.instructor_amount_renewal, subValue: (this.model.instructor_amount_renewal*7) },
              { icon: 'assets/images/ME-Logo-100x100.png', title: 'ME Student', rate: '1 ME = 1$', mainValue:  this.model.eamount_renewal, subValue:(this.model.eamount_renewal*1) },
              { icon: 'assets/images/ME-Logo-100x100.png', title: 'ME Mall', rate: '1 ME = 300$', mainValue: this.model.mall_amount_renewal, subValue: (this.model.mall_amount_renewal*300) },
              { icon: 'assets/images/ME-Logo-100x100.png', title: 'ME Floor', rate: '1 ME = 30$', mainValue: this.model.floor_amount_renewal, subValue: (this.model.floor_amount_renewal*30) },
              { icon: 'assets/images/ME-Logo-100x100.png', title: 'ME Shop', rate: '1 ME = 1$', mainValue: this.model.shop_amount_renewal, subValue: (this.model.mall_amount_renewal) },
            ];

            });

           

      this.CommonService.editdata(this.getpackagevsuserApiUrl,user_id)
          .subscribe(resultdata =>{   
            this.package_vs_user_list=resultdata.result; 
          });    
  
    let translate_url="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    
    if(localStorage.getItem('languageType'))
    {
      var stringLang = localStorage.getItem('languageType');
      this.switchLang(stringLang);
    }else{
      this.switchLang('English');
    }
    
  }

  // public updateWeek(){
  //   //declare total week =700
  //   //start date of week is 20-08-2025 ,every wednesday new week start
  //   //fetc the current date
  //   //find nof days between current date and start date
  //   //calculate nof weeks from nof days (days/7)
  //   //tot_weeks= 700-(calculated weeks)
  //   //current week = tot_weeks
  //   let startDate = new Date('2025-08-20');
  //   let currentDate = new Date();
  //   let timeDiff = Math.abs(currentDate.getTime() - startDate.getTime());
  //   let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)); 
  //   let diffWeeks = Math.floor(diffDays / 7);
  //   this.currentWeek = this.totalWeeks - diffWeeks;
  //   this.nextWeek = this.currentWeek - 1;
  //   console.log("currentWeek",this.currentWeek);
  // }

  public updateWeek() {
    const totalWeeks = 700;

    // Define start date in US timezone (20-Aug-2025 is Wednesday)
    const startDateUS = new Date(Date.UTC(2025, 7, 20)); // August = 7

    // Get the current date in US timezone, converted properly to a Date object
    const currentDateUS = new Date(
      new Intl.DateTimeFormat("en-US", {
        timeZone: "America/New_York",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
      }).format(new Date())
    );

    // --- Calculate the difference in days between current and start date ---
    const timeDiff = currentDateUS.getTime() - startDateUS.getTime();
    let diffDays = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    if (diffDays < 0) diffDays = 0;

    // --- Week resets every Wednesday 12 AM (US time) ---
    const startDay = startDateUS.getUTCDay(); // Wednesday → 3
    const currentDay = currentDateUS.getUTCDay();

    // Adjust so week rolls over every Wednesday
    const daysSinceStartWeek = diffDays - ((7 + (currentDay - startDay)) % 7);
    const diffWeeks = Math.floor(daysSinceStartWeek / 7) + 1;

    // --- Compute current and next week ---
    this.currentWeek = totalWeeks - diffWeeks + 1;
    this.nextWeek = this.currentWeek - 1;

    // --- Debug info ---
    console.log("US Current Date:", currentDateUS.toString());
    console.log("Current Week:", this.currentWeek);
    console.log("Next Week:", this.nextWeek);
  }



  public loadScript(url) {
    console.log('preparing to load...')
    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  logout(){
    this.loginService.logout();
  }
  switchLang(lang: string) {    
    this.translate.use(lang);
    localStorage.setItem('languageType',lang);
  }
  // p
 checkmarketer(marketer_name:any)
 {
   this.model.username=marketer_name;
   this.CommonService.checkexistdata(this.checkUserRestApiUrl,this.model).subscribe(data=>{
      if(data.exist==0)
      {                
         swal('Oops...','Marketer doesnot exists', 'error');
         this.model.mname='';
      }       
    });
  }

checkcvmarketer(marketer_name:any)
 {
    console.log(this.transmodel);
    if(this.transmodel.voucher_type==""||this.transmodel.voucher_type==undefined){
      swal('Oops...','Select Voucher Type', 'error');
      this.transmodel.cvmname='';
    }else{
      this.model.username=marketer_name;
      this.CommonService.checkexistdata(this.checkUserRestApiUrl,this.model).subscribe(data=>{
        if(data.exist==0)
        {                
          swal('Oops...','Marketer doesnot exists', 'error');
          this.transmodel.cvmname='';
        }       
      });
    }
  
  }

  checkcvbalance()
  {     
    this.alldata.user_id=localStorage.getItem('currentUserID');
    this.alldata.shareType = this.transmodel.voucher_type;
    this.alldata.share_amt=this.transmodel.cvshare_amt;
    console.log("checkcvbalance",this.alldata);
    if((this.transmodel.cvshare_amt!='')&&(this.transmodel.cvshare_amt!=undefined))
      {
        this.CommonService.checkexistdata(this.checkUserCreditbyTypeRestApiUrl,this.alldata).subscribe(data=>{
          
            if(data.status==1)
            {
               swal('Oops...',data.message, 'error');
               this.transmodel.cvshare_amt=''; 
            }
          
        });
      }
  }

  transferCvoucher()
  {
    Swal.fire({
    title: 'Transfer ME',
    text: 'Are you sure you want to transfer ME?',
    type: 'warning', // updated 'type' to 'icon' for newer SweetAlert2 versions
    showCancelButton: true,
    confirmButtonColor: '#3051d6ff',
    cancelButtonColor: '#d63030ff',
    confirmButtonText: 'Yes, Transfer',
    cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        this.alldata.transfer_to=this.transmodel.cvmname;
        this.alldata.transfer_from=localStorage.getItem('currentUser');
        this.alldata.shareType = this.transmodel.voucher_type;
        this.alldata.amt=this.transmodel.cvshare_amt;

        $('.preloader loader-3').show();    
        
        this.CommonService.insertdata(AppSettings.trasnfervoucherRestApiUrl,this.alldata)
        .subscribe(package_det =>{
          
            $('.preloader loader-3').hide();      
            swal(
              package_det.status,
              package_det.message,
              package_det.status
            )
            this.transmodel.cvmname = '';
            this.transmodel.cvshare_amt = '';
            this.ngOnInit(); 
        });
      }
    });
  } 



  pay_via_voucher()
  {
    this.payment_details=true;
    
  }
  pay_via_voucher_renew()
  {
    this.renew_payment_details=false;
  }
  savepackages()
  {
    this.CommonService.insertdata(this.insertpackagevsuserApiUrl,this.model)
    .subscribe(package_det =>{   
      if(package_det.status==1)
      {
        Swal.fire({
          title: 'Package has been alloted',
          type: 'success',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Activate Package now?'
        }).then((result) => {
          if (result.value) {
            this.router.navigate(['/packageinfo']);
          }
        })
           $('#largeModal').modal('toggle');
      } else{
        swal('Oops...',package_det.message, 'error');
      }   
        
        //this.router.navigate(['/dashboard']) ; 
    });
  }
  checkbalance(type:any)
  {     
    this.alldata.user_id=localStorage.getItem('currentUserID');
    this.model.share_amt = (type==1)?this.model.share_amt:this.elearningmodel.share_amt;
    this.alldata.shareType = type;
    if((this.model.share_amt!='')&&(this.model.share_amt!=undefined))
      {
        this.alldata.share_amt=this.model.share_amt;
        this.CommonService.checkexistdata(this.checkUserCreditRestApiUrl,this.alldata).subscribe(data=>{
          if(data.total_amount<=50)
          {                
             swal('Oops...','Minimum Amount should be more than 50', 'error');
             this.model.share_amt='';
          }
          else{
            if(data.status==1)
            {
               swal('Oops...',data.message, 'error');
               this.model.share_amt=''; 
            }
          }
        });
      }
  }
  transferamount(type:any)
  {
    this.transferdata.transfer_to=this.model.username;
    this.transferdata.transfer_from=localStorage.getItem('currentUser');
    this.transferdata.type = type;
    this.transferdata.amt=(type==1)?this.model.share_amt:this.elearningmodel.share_amt;
    if(type==1)
    {
      $('.preloader loader-2').show();
    }else{
      $('.preloader loader-1').show();
    }
    
    
    this.CommonService.insertdata(this.inserttrasnfeprocessRestApiUrl,this.transferdata)
    .subscribe(package_det =>{
      if(type==1){
        $('.preloader loader-2').hide();
      }else{
        $('.preloader loader-1').hide();
      }       
         swal(
          package_det.status,
          package_det.message,
          package_det.status
        )
         this.model.mname = '';
         this.model.share_amt = '';
        this.ngOnInit(); 
    });
  }
  transferInstructoramount()
  {
    this.InstructorTransferDate.transfer_to=this.model.username;
    this.InstructorTransferDate.transfer_from=localStorage.getItem('currentUser');
    this.InstructorTransferDate.type = 3;
    this.InstructorTransferDate.amt=this.InstructorTransferDate.share_amt;

    $('.preloader loader-3').show();    
    
    this.CommonService.insertdata(AppSettings.trasnferInstructorRestApiUrl,this.InstructorTransferDate)
    .subscribe(package_det =>{
      
        $('.preloader loader-3').hide();      
         swal(
          package_det.status,
          package_det.message,
          package_det.status
        )
         this.model.mname = '';
         this.model.share_amt = '';
        this.ngOnInit(); 
    });
  } 
  userweb(website_name:any)
  {
    this.model.user_web_url=website_name;
    // this.model.template=template;
     this.CommonService.insertdata(this.userwebsiteurl,this.model)
    .subscribe(package_det =>{       
         swal(
          package_det.status,
          package_det.message,
          package_det.status
        )
        this.router.navigate(['/dashboard']); 
    });
  }
  onGoToPage2(package_name:any,package_price:any,userid:any,pack_id:any,pack_id_user:any,website:any,template:any)
  {
    
    this.model.package_name = package_name;
    this.model.package_price = package_price;
    this.payment_data.userid = userid;//user_vs_package user id
    this.payment_data.pack_id =pack_id;//user_vs_pacakge package if
    this.payment_data.pack_id_user=pack_id_user;//user_vs_packeg mastr id
    this.model.website = website;
    this.checkIswebsite=(this.model.website!='')?true:false;
    this.model.template = template;
    this.model.p_id = pack_id_user;
    
    
    
  }
  
   paytoactivate()
  { 
    this.payment_data.website = this.model.website;
    this.details_array.push(this.payment_data);
   // $('.preloader').show();
    this.isPaid=true;
    //return false;
    this.showButton=true;
     this.CommonService.insertdata(this.packageActivateApiUrl,this.details_array)
    .subscribe(payment_status =>{ 
      if(payment_status.status=='success')
      {
        swal('','Package activated successfully','success');
        this.payment_data='';
        this.model='';
        this.isPaid=false;
         $('#exampleModal').modal('toggle');
          let user_id = localStorage.getItem('currentUserID');
          this.CommonService.editdata(this.getpackageinfodetApiUrl,user_id)
              .subscribe(resultdata =>{   
                this.packagelist=resultdata.result; 
              });
              //$('.preloader').hide();
              
              this.showButton=false;
            }
      else if(payment_status.status=='user_error'){
        swal('','Not a valid user or invalid user data','error');        
        //this.payment_data='';
        //this.model='';
         //this.isPaid=true;
        $('.preloader').hide();
      }
      else if(payment_status.status=='fail'){
        swal('','user has less amount on his own','error');
        $('.preloader').hide();
       // this.payment_data=''; 
        //this.model='';
      }
      else{
        swal('','Error while on activate package','error');
        $('.preloader').hide();
       // this.payment_data=''; 
        //this.model='';
      }
     
    });
  }
  restrictNumbers(event: any)
  {
      const pattern = /[0-9\+\-\ ]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {    
          // invalid character, prevent input
          event.preventDefault();
      }
  }

  selectPackage(){
    this.model.website='';
    this.model.filteredPackDetails=this.packagelistall.filter((pckData: any) => pckData.id == this.model.pcktaken);
    this.model.selected_pck_type = this.model.filteredPackDetails[0].pck_type;
    if(this.model.selected_pck_type==4){
      this.model.selectedwebsite_prefix="p-"
    }
    else if(this.model.selected_pck_type==5){
      this.model.selectedwebsite_prefix="b-"
    }else{
      this.model.selectedwebsite_prefix="";
    }
    
    console.log("selectPackage",this.model.selected_pck_type);
  }
  
onWebsiteChange(value: string) {
  // console.log("onWebsiteChange-->",value);
  this.model.website = value.toLowerCase();
  // console.log("showBuySale-->",this.showBuySale);
  this.showBuySale = false;  // hide when website changes
  this.showBuy = false;
}

  checkInternetLife()
  {
    this.model.pcktaken='17'; //Personal Life
    this.model.selectedwebsite_prefix='p-';
    if(this.model.website=="" || this.model.website==undefined ){
      swal('','Enter Internet Life','error');
      this.showBuySale = false;
      this.showBuy = false;
      this.model.website='';
    }else{
      this.CommonService.checkexistdata(this.CheckwebsiteExistsRestApiUrl,this.model)
    .subscribe(package_det =>{
      if(package_det.exist==1&& package_det.sale_status==0)
      {
        swal('',package_det.message,'error')
        this.model.website='';
        this.showBuy = false;
        this.showBuySale = false;
      } 
      
      if(package_det.exist==1&& package_det.sale_status==1)
      {
        this.model.sale_internet_life_detail=package_det.internet_life_sale[0];
        this.showBuySale = true;
        this.showBuy = false;
      }else{
        this.showBuySale = false;
        this.showBuy = false;
      }

      if(package_det.exist==0){
         this.showBuy = true;
      }
    });
    }
    
  }

  selectOption(option: string) {
    this.selectedOption = option;
    this.showLoginForm = true;
  }

  confirm() {
  if (
    this.model.sale_internet_life_detail_user_name == "" ||
    this.model.sale_internet_life_detail_user_name == undefined ||
    this.model.sale_internet_life_detail_user_password == "" ||
    this.model.sale_internet_life_detail_user_password == undefined
  ) {
    swal("Oops...", "Enter Valid Life Lock and Key", "error");
    return;
  }

  let actionText =
    this.selectedOption === "activate"
      ? "Buy for Activate Internet Life"
      : this.selectedOption === "sale"
      ? "Buy for Sale Internet Life"
      : "Buy New Internet Life";

  swal({
    title: "Are you sure?",
    text: `Do you want to ${actionText}?`,
    icon: "warning",
    buttons: ["Cancel", "Yes"],
    dangerMode: true,
  }).then((willProceed) => {
    if (willProceed) {
      if (this.selectedOption === "activate") {
        // Activate
        this.model.sale_internetlife_voucherType = 18; // dollar
        this.model.sale_internetlife_status = 2; // 2 for active
        this.model.website_block_status = 2; // 2 for website is activate
      } else if (this.selectedOption === "sale") {
        // Sale
        this.model.sale_internetlife_voucherType = 18; // dollar
        this.model.sale_internetlife_status = 1; // 1 for sale
        this.model.website_block_status = 1; // 1 for website is sale
      } else {
        // New Buy
        this.model.sale_internetlife_voucherType = 17; // MEAI
        this.model.sale_internetlife_status = 1; // 1 for sale
        this.model.website_block_status = 1; // 1 for website is sale
      }

      // API Call
      this.CommonService.insertdata(AppSettings.buyinternetlife, this.model)
        .subscribe((resdetail) => {
          if (resdetail.status == 0) {
            swal("", resdetail.message, "success").then(() => {
              this.cancel();
              this.router.navigate(["/manageinternetlife"]);
            });
          }
          if (resdetail.status == 1) {
            swal("Oops...", resdetail.message, "error");
          }
        });
    }
  });
}

openComingSoon() {
      $('#showComingSoon').modal('toggle');
  }

  closeComingSoon() {
      $('#showComingSoon').modal('toggle');
  }

  toggleShortMenu() {
  this.showShortMenu = !this.showShortMenu;
}


  cancel() {
    this.showLoginForm = false;
    this.selectedOption = '';
    this.model.website='';
    this.showBuySale = false;
    this.showBuy = false;
  }

  // Update convert_to options based on convert_from
  getConvertToOptions() {
    if (this.convertmodel.convert_from === 'Dollar') {
      return [{ value: '19', label: 'AI Dollar' }];
    } else if (this.convertmodel.convert_from === 'AI Dollar') {
      return [
        { value: '17', label: 'ME AI' },
        { value: '7', label: 'ME Main' }
      ];
    } else {
      return [];
    }
  }

  // Calculate conversion dynamically
  calculateConversion() {
    const amt = Number(this.convertmodel.convert_amt) || 0;
    const type = this.convertmodel.convert_to;
    this.convertmodel.converted_value = 0;
    this.convertmodel.convert_amt = "";

    if (type === '19') {
      this.convertmodel.converted_value = amt * this.melist.ai_dollar;
    } else if (type === '17') {
      this.convertmodel.converted_value = amt * this.melist.me_ai;
    } else if (type === '7') {
      this.convertmodel.converted_value = amt * this.melist.me_main;
    } else {
      this.convertmodel.converted_value = 0;
    }
  }

  // Convert button click
  convertME() {
    if (!this.convertmodel.convert_from || !this.convertmodel.convert_to || !this.convertmodel.convert_amt) {
      alert('Please fill all fields before converting.');
      return;
    }

    if (this.convertmodel.convert_from === 'Dollar') {
      this.alldata.shareType = 18;
    } else if (this.convertmodel.convert_from === 'AI Dollar') {
      this.alldata.shareType = 19;
    } else {
      this.alldata.shareType = null; // default / safety fallback
    }

    this.alldata.user_id=localStorage.getItem('currentUserID');
    this.alldata.share_amt=this.convertmodel.convert_amt;
    if((this.convertmodel.convert_amt!='')&&(this.convertmodel.convert_amt!=undefined))
    {
      this.CommonService.checkexistdata(this.checkUserCreditbyTypeRestApiUrl,this.alldata).subscribe(data=>{
        
          if(data.status==1)
          {
              swal('Oops...',data.message, 'error');
              this.convertmodel.convert_amt=''; 
              this.convertmodel.converted_value = 0;
          }
        
      });
    }
    const postData = {
      user_id: localStorage.getItem('currentUserID'),
      convert_from: this.convertmodel.convert_from,
      convert_to: this.convertmodel.convert_to,
      convert_from_id: this.alldata.shareType,
      convert_amt: this.convertmodel.convert_amt,
      converted_value: this.convertmodel.converted_value
    };

    console.log("Conversion Request:", postData);

    Swal.fire({
    title: 'Convert ME',
    text: 'Are you sure you want to Convert?',
    type: 'warning', // updated 'type' to 'icon' for newer SweetAlert2 versions
    showCancelButton: true,
    confirmButtonColor: '#3051d6ff',
    cancelButtonColor: '#d63030ff',
    confirmButtonText: 'Yes, Convert',
    cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        this.CommonService.updatedata(this.convertmeApiUrl, postData)
        .subscribe(res => {
          swal(res.status, res.message);
          this.convertmodel = { convert_from: '', convert_to: '', convert_amt: "", converted_value: "" };
          this.router.navigate(["/manageconverthistory"]);
        });
      }
    });

    
  }
  
}
